import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CustomerForEdit } from '../models';

@Injectable({ providedIn: 'root' })
export class CustomerService {
	endpointBase = '/api/customers';

	constructor(private readonly http: HttpClient) {}

	getList(siteId?: number): Observable<any> {
		return this.http.get(`${this.endpointBase}`, { params: { siteId } });
	}

	createEntity(entity: CustomerForEdit): Observable<any> {
		return this.http.post(`${this.endpointBase}`, entity);
	}

	searchCustomers(searchText: string, siteId?: number, onlyActive?: boolean, limit?: number): Observable<any> {
		return this.http.get<any>(`${this.endpointBase}/search-customers`, {
			params: { searchText, siteId: siteId?.toString(), onlyActive: onlyActive.toString(), limit: limit?.toString() },
		});
	}
}
